export default "__VITE_ASSET__DkdnSQAk__"